<ng-template #createAssessmentModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      @if (!isReInvite) {
        <h3>Create New Subject File</h3>
      }
      @if (isReInvite) {
        <h3>Re-Invite Examinee</h3>
      }
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="mainForm" (ngSubmit)="onSubmit()">

        @if (!isReInvite) {
          @if (!isSubjectFinalized) {
            <fieldset formGroupName="subjectInfo">
              <div class="mb-3">
                <label for="subject_id" class="form-label">Search Subject by ID <span class="text-danger">*</span></label>
                <input type="text" id="subject_id" class="form-control" formControlName="subject_id" placeholder="Start typing a subject ID..." [ngClass]="{ 'is-invalid': submitted && subjectInfoControls['subject_id'].errors }">
                @if (submitted && subjectInfoControls['subject_id'].errors) {
                  <div class="invalid-feedback"> A Subject ID is required. </div>
                }
              </div>
            </fieldset>
          }
          @if (showResultsTable) {
            <div class="card card-body mb-3">
              @if (isSearching) {
                <div class="text-center p-3">
                  <em>Searching...</em>
                </div>
              }
              @if (!isSearching) {
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th class="text-end">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (subject of searchResults; track subject) {
                        <tr>
                          <td>{{ subject.subject_id }}</td>
                          <td>{{ subject.subject_details.first_name }}</td>
                          <td>{{ subject.subject_details.last_name }}</td>
                          <td class="text-end">
                            <button type="button" class="btn btn-sm btn-primary" (click)="onSubjectSelect(subject)">Select</button>
                          </td>
                        </tr>
                      }
                      @if (searchResults.length === 0) {
                        <tr>
                          <td colspan="4" class="text-center text-muted">No subjects found.</td>
                        </tr>
                      }
                    </tbody>
                    @if (!isSearching && !exactMatchFound && subjectInfo.get('subject_id')?.value) {
                      <tfoot>
                        <tr>
                          <td colspan="4" class="text-center pt-3 border-bottom-0">
                            <span>-- OR --</span><br />
                            <button type="button" class="btn btn-sm btn-success mt-1" (click)="onCreateNew()">
                              Create New Subject with ID "{{ subjectInfo.get('subject_id')?.value }}"
                            </button>
                          </td>
                        </tr>
                      </tfoot>
                    }
                  </table>
                </div>
              }
            </div>
          }
        }

        @if (isSubjectFinalized) {
          <div>
            <div class="row mb-3">
              <div class="col-lg-6">
                <div class="card card-body h-100">
                  <h5 class="card-title mb-3">Subject Details</h5>
                  <fieldset formGroupName="subjectInfo">
                    <div class="mb-3">
                      <label for="subject_id_final" class="form-label">Subject ID</label>
                      <input type="text" id="subject_id_final" class="form-control" formControlName="subject_id">
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label for="first_name" class="form-label">First Name <span class="text-danger">*</span></label>
                          <input type="text" id="first_name" class="form-control" formControlName="first_name" placeholder="Enter first name" [ngClass]="{ 'is-invalid': submitted && subjectInfoControls['first_name'].errors }">
                          @if (submitted && subjectInfoControls['first_name'].errors) {
                            <div class="invalid-feedback"> First name is required. </div>
                          }
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label for="last_name" class="form-label">Last Name <span class="text-danger">*</span></label>
                          <input type="text" id="last_name" class="form-control" formControlName="last_name" placeholder="Enter last name" [ngClass]="{ 'is-invalid': submitted && subjectInfoControls['last_name'].errors }">
                          @if (submitted && subjectInfoControls['last_name'].errors) {
                            <div class="invalid-feedback"> Last name is required. </div>
                          }
                        </div>
                      </div>
                    </div>
                    @if (!assessment) {
                      <div class="mb-3">
                        <label for="case_owner_id" class="form-label">Subject File Owner <span class="text-danger">*</span></label>
                        <ng-select [loading]="usersLoading" [items]="users" id="case_owner_id" bindValue="client_user_id" placeholder="Select Subject File Owner" formControlName="case_owner_id" (search)="onSearchUser($event)" [searchFn]="customSearchFn" [ngClass]="{ 'is-invalid': submitted && subjectInfoControls['case_owner_id'].errors }">
                          <ng-template ng-label-tmp let-item="item">
                            {{ item.user_details.first_name }} {{ item.user_details.last_name }}
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            {{ item.user_details.first_name }} {{ item.user_details.last_name }}
                            <small class="text-muted d-block">{{ item.user_details.email }}</small>
                          </ng-template>
                          <ng-template ng-loadingspinner-tmp>
                            <div class="d-flex justify-content-center py-2 px-2">
                              <div class="spinner-border spinner-border-sm text-warning" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          </ng-template>
                        </ng-select>
                        @if (submitted && subjectInfoControls['case_owner_id'].errors) {
                          <div class="invalid-feedback"> Please select a subject file owner. </div>
                        }
                      </div>
                    }
                    @if (assessment) {
                      <div class="mb-3">
                        <label class="form-label">Subject File Owner</label>
                        <input type="text" class="form-control" [value]="caseOwnerName" readonly disabled>
                      </div>
                    }
                  </fieldset>
                </div>
              </div>
              <div class="col-lg-6">
                <fieldset formGroupName="associationDetails" class="card card-body h-100">
                  <h5 class="card-title mb-3">Association</h5>
                  <div class="mb-3">
                    <div class="form-check mb-2">
                      <input class="form-check-input" type="radio" id="assocYes" value="yes" formControlName="hasAssociation">
                      <label class="form-check-label" for="assocYes">Select an associate</label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="assocNo" value="no" formControlName="hasAssociation">
                      <label class="form-check-label" for="assocNo">No associate for this assessment</label>
                    </div>
                  </div>
                  @if (associationDetails.get('hasAssociation')?.value === 'yes') {
                    <div>
                      @if (!isReInvite) {
                        <hr>
                        }
                        @if (isAddingNewAssociate && !isReInvite) {
                          <div formGroupName="newAssociateDetails">
                            <h6 class="mb-3">Add New Associate</h6>
                            <div class="row">
                              <div class="col-md-4 mb-3">
                                <label class="form-label">ID <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="associate_id" [ngClass]="{ 'is-invalid': newAssociateControls['associate_id'].touched && newAssociateControls['associate_id'].errors }">
                              </div>
                              <div class="col-md-4 mb-3">
                                <label class="form-label">First Name <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="first_name" [ngClass]="{ 'is-invalid': newAssociateControls['first_name'].touched && newAssociateControls['first_name'].errors }">
                              </div>
                              <div class="col-md-4 mb-3">
                                <label class="form-label">Last Name <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="last_name" [ngClass]="{ 'is-invalid': newAssociateControls['last_name'].touched && newAssociateControls['last_name'].errors }">
                              </div>
                              <div class="col-md-12 mb-3">
                                <label class="form-label">Role <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="role" [ngClass]="{ 'is-invalid': newAssociateControls['role'].touched && newAssociateControls['role'].errors }">
                              </div>
                            </div>
                            <div class="text-end">
                              <button type="button" class="btn btn-sm btn-light me-2" (click)="cancelAddNewAssociate()">Cancel</button>
                              <button type="button" class="btn btn-sm btn-success" (click)="onSaveNewAssociate()">Save & Select</button>
                            </div>
                          </div>
                        }
                        @if (!isAddingNewAssociate) {
                          <div>
                            <label class="form-label">Associate</label>
                            <div class="list-group mb-2">
                              @for (assoc of availableAssociates; track assoc) {
                                <a
                                  (click)="!isReInvite && onAssociateSelect(assoc)"
                                  class="list-group-item list-group-item-action"
                                  [class.active]="associationDetails.get('selectedAssociateId')?.value === assoc.associate_id"
                                  [class.disabled]="isReInvite">
                                  <div class="d-flex w-100 justify-content-between pointer">
                                    <span>{{ assoc.associate_details.first_name }} {{ assoc.associate_details.last_name }}</span>
                                    <small>{{ assoc.associate_details.role }}</small>
                                  </div>
                                </a>
                              }
                            </div>
                            @if (!newAssociateAdded && !isReInvite) {
                              <button type="button" class="btn btn-link px-0" (click)="showAddNewAssociateForm()">+ Add New Associate</button>
                            }
                          </div>
                        }
                      </div>
                    }
                  </fieldset>
                </div>
              </div>
            </div>
          }

          @if (isAssociationFinalized && !isReInvite) {
            <div class="mb-3">
              <h5 class="form-label">Assessment Type <span class="text-danger">*</span></h5>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-lg flex-fill" [class.btn-primary]="selectedSubForm === 'conversation'" [class.btn-outline-secondary]="selectedSubForm !== 'conversation'" (click)="selectSubForm('conversation')"> Open Conversation </button>
                <button type="button" class="btn btn-lg flex-fill" [class.btn-primary]="selectedSubForm === 'examinee'" [class.btn-outline-secondary]="selectedSubForm !== 'examinee'" (click)="selectSubForm('examinee')"> Questionnaire </button>
              </div>
            </div>
          }

          @if (isAssociationFinalized || isReInvite) {
            <div>
              @switch (selectedSubForm) {
                @case ('conversation') {
                  <div formGroupName="conversationDetails" class="card card-body mb-0" style="box-shadow: none">
                    <h5 class="card-title mb-3">Open Conversation Details</h5>
                    <div class="mb-3">
                      <label for="name" class="form-label">Conversation Name <span class="text-danger">*</span></label>
                      <input type="text" id="name" class="form-control" formControlName="name" placeholder="Enter conversation name" [ngClass]="{ 'is-invalid': submitted && conversationControls['name'].errors }">
                      @if (submitted && conversationControls['name'].errors) {
                        <div class="invalid-feedback"> Conversation name is required. </div>
                      }
                    </div>
                    <div class="mb-3">
                      <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                      <input type="email" class="form-control" id="email" placeholder="Enter email address" formControlName="email" [ngClass]="{ 'is-invalid': submitted && conversationControls['email'].errors }">
                      @if (submitted && conversationControls['email'].errors) {
                        <div class="invalid-feedback"> Please enter a valid email. </div>
                      }
                    </div>
                  </div>
                }
                @case ('examinee') {
                  <div formGroupName="examineeDetails" class="card card-body mb-0" style="box-shadow: none">
                    <h5 class="card-title mb-3">{{ isReInvite ? 'Re-Invite Details' : 'Questionnaire Invitation Details' }}</h5>
                    <div class="mb-3">
                      <label for="questionnaire" class="form-label">Questionnaire <span class="text-danger">*</span></label>
                      <ng-select [loading]="questionnaireLoading" [items]="questionnaires" id="questionnaire" bindLabel="name" bindValue="id" placeholder="Select Questionnaire" formControlName="questionnaireId" (search)="onSearchQuestionnaire($event)" [ngClass]="{ 'is-invalid': submitted && examineeControls['questionnaireId'].errors }"></ng-select>
                      @if (submitted && examineeControls['questionnaireId'].errors) {
                        <div class="invalid-feedback"> Please select a questionnaire. </div>
                      }
                    </div>
                    <div class="mb-3">
                      <label for="examinee-email" class="form-label">Email <span class="text-danger">*</span></label>
                      <input type="email" class="form-control" id="examinee-email" placeholder="Enter email address" formControlName="email" [ngClass]="{ 'is-invalid': submitted && examineeControls['email'].errors }">
                      @if (submitted && examineeControls['email'].errors) {
                        <div class="invalid-feedback"> Please enter a valid email. </div>
                      }
                    </div>
                    <div class="mb-3">
                      <label for="date-field" class="form-label">{{ isReInvite ? 'New Expiration Date' : 'Expiration Date' }} <span class="text-danger">*</span></label>
                      <input class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="false" [altFormat]="'Y-m-d H:i'" [minDate]="minExpiryDate" [enableTime]="true" [dateFormat]="'Y-m-d H:i'" [convertModelValue]="false" formControlName="time_expiration" [ngClass]="{ 'is-invalid': submitted && examineeControls['time_expiration'].errors }">
                      <div class="invalid-feedback">Please select a date.</div>
                    </div>
                  </div>
                }
              }
            </div>
          }

          <div class="text-end mt-3">
            <button type="submit" class="btn btn-primary btn-load" [disabled]="!mainForm.valid || (!isReInvite && (!isAssociationFinalized || !selectedSubForm))">
              <span class="d-flex justify-content-center">
                @if (submitted && spinner) {
                  <span class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                }
                <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ isReInvite ? 'Re-Send Invite' : 'Create' }} </span>
              </span>
            </button>
          </div>

        </form>
      </div>

      @if (message !== '') {
        <div class="modal-footer">
          <p class="text-center text-danger mx-4 mb-0">*{{ message }}</p>
        </div>
      }
    </div>
  </ng-template>